<n-slide-window [visible]="windowVisible"
    width="6.08rem"
    (onHide)="hide()">
    <n-header class="flex-wrapper">
        <h1>
            {{i18n.modifyShareNameTitle}}
            <n-help-link key="simplifyshareCreate"></n-help-link>
        </h1>
    </n-header>

    <form class="form-width-simple"
        [simpleMode]="true"
        [formGroup]="vm"
        [errorMessage]="errorMessage">
        <!-- nfs共享名称 -->
        <n-form-item [label]="i18n.nfsShareNameLab" [showAvailableLabel]="true" *ngIf="data.showNfsShareForm">
            <input type="text"
                id="modify_nfs_share_name"
                nInput
                formControlName="nfsShareName">
        </n-form-item>
        <!-- cifs共享名称 -->
        <n-form-item [required]="true" [label]="i18n.cifsShareNameLab" *ngIf="data.cifsShareName">
            <input type="text"
                id="modify_cifs_share_name"
                nInput
                formControlName="cifsShareName">
        </n-form-item>
    </form>

    <n-footer>
        <button nButton
            id="modify-fs-intra-migration-ok-btn"
            type="button"
            theme="primary"
            [label]="i18n.okBtn"
            (click)="onOk()">
        </button>
        <button nButton
            id="modify-fs-intra-migration-cancel-btn"
            type="button"
            [label]="i18n.cancelBtn"
            (click)="hide()">
        </button>
    </n-footer>
</n-slide-window>
